<template>
  <div >
    <div class="banner">
      <h1><img src="@/assets/banner.png" style="display:block; width:100%;"></h1>
    </div>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>精品热销课</span> 
        </div>
        <el-row :gutter="20">
            <el-col :span="6" v-for="o in productList2" :key="o.id">
                <div class="product" @click="turn2(o)">
                    <div class="img">
                        <img :src="o.img" />
                    </div>
                    <div class="title">{{o.name}}</div>
                    <div class="price">￥{{o.price}}/{{o.unit}}</div>
                </div>
            </el-col>
        </el-row>
    </el-card>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>菌群检测</span> 
        </div>
        <el-row :gutter="20">
            <el-col :span="6" v-for="o in productList1" :key="o.id">
                <div class="product" @click="turn(o)">
                    <div class="img">
                        <img :src="o.img" />
                    </div>
                    <div class="title">{{o.name}}</div>
                    <div class="price">￥{{o.price}}/{{o.unit}}</div>
                </div>
            </el-col>
        </el-row>
    </el-card>
  </div>
</template>

<script>
import img1 from '@/assets/img1.png'
import big1 from '@/assets/big1.png'
import img2 from '@/assets/img2.png'
import big2 from '@/assets/big2.png'
import img3 from '@/assets/img3.png'
import big3 from '@/assets/big3.png'
import img4 from '@/assets/img4.png'
import big4 from '@/assets/big4.png'
import kc01 from '@/assets/001.png'
import kc02 from '@/assets/002.png'
import kc03 from '@/assets/003.png'
import kcb01 from '@/assets/big001.png'
import kcb02 from '@/assets/big002.png'
import kcb03 from '@/assets/big003.png'
export default {
  name: 'Home',
  data : function(){
    return {
      productList1 : [{
          id : 2,
          name : '孕期妇女膳食评估',
          price : '300',
          unit : '次',
          img : img1,
          bigImg : big1
      },{
          id : 1,
          name : '哺乳期少女膳食评估',
          price : '300',
          unit : '次',
          img : img2,
          bigImg : big2
      },{
          id : 3,
          name : '学龄前儿童膳食评估',
          price : '260',
          unit : '次',
          img : img3,
          bigImg : big3
      },{
          id : 4,
          name : '3-5岁儿童唾液酸营养包',
          price : '880',
          unit : '次',
          img : img4,
          bigImg : big4
      }],
      productList2 : [{
          id : 5,
          name : '为什么要关注孕期营养？',
          price : '9.9',
          unit : '节',
          img : kc01,
          bigImg : kcb01
      },{
          id : 6,
          name : '碘适量与甲状腺功能的关系？',
          price : '9.9',
          unit : '节',
          img : kc02,
          bigImg : kcb02
      },{
          id : 7,
          name : '为什么要注重孕产期的体重管理？',
          price : '9.9',
          unit : '节',
          img : kc03,
          bigImg : kcb03
      }]
    }
  },
  methods : {
      turn(obj){
          window.localStorage.setItem('product',JSON.stringify(obj))
          this.$router.push({
              path : 'detail/'+obj.id
          })
      },
       turn2(obj){
          window.localStorage.setItem('product',JSON.stringify(obj))
          this.$router.push({
              path : 'detail2/'+obj.id
          })
      }
  }
}
</script>

<style>
.product{
    text-align: left;
    line-height: 1.5;
    position: relative;
}
.product .img img{
    width: 100%;
}
.product .title{
    
}
.product .price{
    
    color: #BD82A6;
}
.product .buy{
    background: #000000;
    border-radius: 2px;
    position: absolute;
    right: 0;
    bottom: 0;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue